'use strict';

const { navigation } = require('./navigation.js');

navigation();
